'use client';

import { Swiper, SwiperSlide } from 'swiper/react';

import { MainContainer } from '@/shared/components/mainContainer';
import { SmallCard } from '@/shared/components/smallCard';
import { classNames } from '@/shared/lib/classNames/classNames';

interface AdvantagesProps {
  list: {
    imageSrc: string;
    description: string;
    subDescription?: string;
    href?: string;
    alt: string;
  }[];
  customClassNames?: {
    card: {
      className?: string;
      content: string;
      subDescription: string;
    };
  };
}

const Advantages: React.FC<AdvantagesProps> = ({ list, customClassNames }) => (
  <section className="mb-28 max-sm:mb-16">
    <MainContainer>
      <div className="hidden grid-cols-1 gap-6 sm:grid sm:grid-cols-2 sm:gap-8 lg:grid-cols-4">
        {list.map(
          ({ imageSrc, description, href, alt, subDescription }, index) => (
            <SmallCard
              descriptionId={description}
              key={index}
              imageSrc={imageSrc}
              description={description}
              subDescription={subDescription}
              href={href}
              alt={alt}
              customClassNames={{
                ...customClassNames?.card,
                main: classNames({
                  cls: 'w-full',
                  additional: [customClassNames?.card.className],
                }),
              }}
              isAnimateLinkIcon
            />
          ),
        )}
      </div>
    </MainContainer>
    <div className="block w-full sm:hidden">
      <Swiper spaceBetween={12} slidesPerView="auto" className="!px-8 !py-2">
        {list.map(
          ({ imageSrc, description, href, alt, subDescription }, index) => (
            <SwiperSlide>
              <SmallCard
                key={index}
                alt={alt}
                href={href}
                description={description}
                descriptionId={description}
                subDescriptionId={subDescription}
                subDescription={subDescription}
                imageSrc={imageSrc}
                customClassNames={{
                  ...customClassNames?.card,
                  main: classNames({
                    cls: 'w-full',
                    additional: [customClassNames?.card.className],
                  }),
                }}
              />
            </SwiperSlide>
          ),
        )}
      </Swiper>
    </div>
  </section>
);

export default Advantages;
